import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconGym: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.6999 7.30002L19.8999 5.50002L20.6999 4.70002C21.0999 4.30002 21.0999 3.70002 20.6999 3.30002C20.2999 2.90002 19.6999 2.90002 19.2999 3.30002L18.4999 4.10002L16.6999 2.30002C16.3999 2.00002 15.8999 1.90002 15.4999 2.10002L11.4999 4.10002C11.2999 4.20002 11.0999 4.50002 10.9999 4.80002C10.9999 5.20002 11.0999 5.50002 11.2999 5.70002L14.0999 8.50002L8.4999 14.1L5.6999 11.3C5.4999 11.1 5.1999 11 4.7999 11C4.4999 11.1 4.1999 11.3 4.0999 11.6L2.0999 15.6C1.8999 16 1.9999 16.4 2.2999 16.8L4.0999 18.6L3.2999 19.4C2.8999 19.8 2.8999 20.4 3.2999 20.8C3.4999 20.9 3.6999 21 3.9999 21C4.2999 21 4.4999 20.9 4.6999 20.7L5.4999 19.9L7.2999 21.7C7.4999 21.9 7.6999 22 7.9999 22C8.1999 22 8.2999 22 8.3999 21.9L12.3999 19.9C12.6999 19.8 12.8999 19.5 12.8999 19.2C12.9999 18.9 12.7999 18.6 12.5999 18.3L9.7999 15.5L15.3999 9.90002L18.1999 12.7C18.3999 12.9 18.5999 13 18.8999 13C18.9999 13 18.9999 13 19.0999 13C19.3999 12.9 19.6999 12.7 19.7999 12.5L21.7999 8.50002C22.0999 8.10002 21.9999 7.60002 21.6999 7.30002ZM8.1999 19.8L4.1999 15.8L5.2999 13.7L10.2999 18.7L8.1999 19.8ZM18.6999 10.3L13.6999 5.30002L15.7999 4.20002L19.7999 8.20002L18.6999 10.3Z',
    })
  )
}
